export const MenuCategory = {
  Dashboard: 0,
  Administration: 1,
  MoreApps: 2,
  AccountSettings: 3,
};
